import React, { useContext, useEffect, useState } from "react";
import StoreMenu from "../../StoreMenu";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../../../utils/localStorage";
import { ProgressSpinner } from "primereact/progressspinner";
import { getAppService, getBrandAppService } from "../../../services/BrandAppServices";
import AppServiceStatusChange from "./AppServiceStatusChange";
import AppServiceAddModal from "./AppServiceAddModal";
import AppServicePriority from "./AppServicePriority";
import AdminMenu from "../../AdminMenu";

const AppServiceList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = location.state || {}; // Fallback to prevent undefined errors

  const [visible, setVisible] = useState(false);
  const [selectedItemValue, setSelectedItemValue] = useState(null);
  const [selectedAppServiceValue, setSelectedAppServiceValue] = useState(null);
  const [modalMenuVisible, setModalMenuVisible] = useState(false);
  const [appServiceList, setAppServiceList] = useState('');


  const [appServicePriorityModalVisible, setAppServicePriorityModalVisible] =
  useState(false);

   const [selectedPriorityItemValue, setSelectedPriorityItemValue] =
     useState(null);



  const [loading, setLoading] = useState(false);

  const {brandProfileData } = getUserData();
  let brandId = brandProfileData.id;

  const fetchAppService = () => {
    setLoading(true);
    getBrandAppService(brandId)
      .then(response => {
        if (!response.data.error) {
          const res = response.data;
          setAppServiceList(res);
          setLoading(false);
        }
      })
      .catch(err => {
        console.error('Error:', err);
      });

    getAppService()
      .then(response => {
        if (!response.data.error) {
          const res = response.data;
          setSelectedAppServiceValue(res);
        }
      })
      .catch(err => {
        console.error('Error:', err);
      });
  };

  useEffect(() => {
    fetchAppService();
  }, []);

  const [appServiceAddModalVisible, setAppServiceAddModalVisible] =
    useState(false);

  const receiveDataFromAppServiceAddModal = ({success}) => {
    if (success) {
      fetchAppService();
    }
  };

   const receiveDataFromAppServicePriorityModal = ({success}) => {
     if (success) {
       fetchAppService();
       setSelectedItemValue(null);
     }
   };

  const renderCardItem = (data) => {
    return data?.map((item, index) => {
      return (
        <div>
          <div className="flex-1 ">
            <div className="m-4 shadow-4">
              <div className="flex flex-1">
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Name :
                  </p>
                  <p className="text-lg font-medium capitalize">
                  {item.appService.name} {item.code ? "(" + item.code + ")" : "" }
                  </p>
                </div>
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Priority :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {item.priority}
                  </p>
                </div>
                <div
                  className="flex-1 px-3 py-1 flex justify-content-between"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <div>
                    <p
                      className="text-md font-normal capitalize"
                      style={{ color: "#75879B" }}
                    >
                      Edit :
                    </p>
                    <div
                    className="mr-4 mt-2"
                    onClick={() => {
                      setAppServicePriorityModalVisible(true);
                  setSelectedPriorityItemValue(item);
                    }}
                  >
                    <i
                      className="pi pi-pencil"
                      style={{
                        fontSize: "20px",
                        cursor: "pointer",
                        color: "#2B70D7",
                      }}
                    ></i>
                  </div>
                  </div>
                </div>
              
                <div
                  className="flex-1 px-3 py-1 flex justify-content-between"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <div>
                    <p
                      className="text-md font-normal capitalize"
                      style={{ color: "#75879B" }}
                    >
                      Status
                    </p>
                    <p className="text-lg font-medium capitalize">{item.status === true ? "Active" : "DeActive"}{" "}</p>
                  </div>
                  <AppServiceStatusChange
                    status={item.status}
                    sendDataToAppService={receiveDataFromAppServiceAddModal}
                    editData={item}
                    brandId={brandId}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() =>
                    navigate("/Setting", {
                      state: {
                        id: id,
                      },
                    })
                  }
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                App Services
              </p>
            </div>
          </div>
          <div
            className="flex justify-content-center align-items-center cursor-pointer mr-4"
            onClick={() =>  {
                setAppServiceAddModalVisible(true);
                setSelectedItemValue(null);
            }
                }
          >
            <img src="images/plus.png" alt="plus" style={{width:30}}/>
          </div>
          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div>
        {loading ? (
          <div style={{ flex: 1 }}>
            <div className="text-center">
              <ProgressSpinner
                style={{ width: "70px", height: "70px" }}
                strokeWidth="4"
                fill="var(--surface-ground)"
                animationDuration="2s"
              />
            </div>
          </div>
        ) : appServiceList?.length > 0 ? (
          <div>
            <div>{renderCardItem(appServiceList)}</div>
          </div>
        ) : (
          <div className="flex justify-content-center align-items-center">
            <p className="text-xl font-medium">No App Service Found</p>
          </div>
        )}
      </div>
      {appServiceList && selectedAppServiceValue && appServiceAddModalVisible && <AppServiceAddModal
          appServiceAddModalVisible={appServiceAddModalVisible}
          setAppServiceAddModalVisible={setAppServiceAddModalVisible}
          sendDataToAppService={receiveDataFromAppServiceAddModal}
          brandId={brandId}
          selectedAppServiceValue={selectedAppServiceValue}
          appServiceList={appServiceList}
        />}
         <AppServicePriority
          setAppServicePriorityModalVisible={setAppServicePriorityModalVisible}
          appServicePriorityModalVisible={appServicePriorityModalVisible}
          sendDataToAppServicePriorityModal={
            receiveDataFromAppServicePriorityModal
          }
          brandId={brandId}
          selectedPriorityItemValue={selectedPriorityItemValue}
        />
      <AdminMenu setVisible={setVisible} visible={visible} />
    </div>
  );
};

export default AppServiceList;
